import { IFetchUpdateDataRequestDTO } from 'modules/customer/domain/dtos';
import { ICustomerUpdateRequestsRepository } from 'modules/customer/domain/repositories';

export class FetchUpdateDataRequestUseCase {
  constructor(
    private customerUpdateRequestsRepository: ICustomerUpdateRequestsRepository,
  ) {}

  public async execute({ hash }: IFetchUpdateDataRequestDTO) {
    return this.customerUpdateRequestsRepository.findByHash({
      hash,
    });
  }
}
